import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles(() => ({
    wrap: {
        display: 'flex',justifyContent: 'center', width: '100%',
    },
    wrapDialog: {
        width: 250, 
        height: 100, 
        padding: 20, 
        display: 'flex', 
        flexDirection: 'column'
    },
    titleDialog: {
        textAlign: 'center'
    },
    dialogButton: {
        color: 'rgb(36, 38, 62)',
        background: 'rgb(255, 206, 1)',
        border: '1px solid rgb(255, 206, 1)',
        padding: '5px 10px',
        borderRadius: '16px',
        maxHeight: '48px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        textTransform: 'uppercase',
        fontSize: 14,
        fontFamily: "PT Sans, sans-serif",
        userSelect: 'none',
        cursor: 'pointer',
        fontWeight: 700,
        textAlign: 'center'
    },
    ok: {
        background: 'rgb(0, 231, 110)',
        color: 'rgb(36, 38, 62)',
        border: 'none',
        borderRadius: 4,
        marginRight: 12,
        width: 100,
    },
    cancel: {
        background: 'rgb(142, 22, 0)',
        color: '#fff',
        border: 'none',
        borderRadius: 4,
        marginRight: 12,
        width: 100,
    }
}))

export {
    useStyles
}